import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

const BackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
`

const BackgroundInner = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1920px;
  height: 100%;

  svg {
    position: absolute;
    top: 25vh;
    left: 0;
    right: 0;
  }

  @media (max-width: 415px) {
    height: 100vw !important;
    max-height: 350px;
    svg {
      top: -15vh !important;
    }
  }
  @media (max-width: 900px) {
    height: 45vh;
    width: 100%;
    svg {
      top: -50vh;
      width: 100%;
    }
  }
`

const BackgroundImage = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1920px;
  height: 100%;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
`

const Background = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "background.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const fluid = data.placeholderImage.childImageSharp.fluid

  return (
    <BackgroundWrapper>
      <BackgroundInner>
        <BackgroundImage src={fluid.src} />

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1920.143"
          height="837.588"
          viewBox="0 0 1920.143 837.588"
        >
          <g id="home" transform="translate(-664 -2036.622)">
            <path
              d="M-26,866.587V244.7S315.474,427.319,685.92,348.5c80.153-17.054,142.788-33.193,194.775-48.408,141.653-74.548,265.366-151.557,430.3-169.006,93.241-9.864,187.621,9.077,272.542,39.107C1766,189,1894,247.849,1894,247.849v93.773l.143.115V866.587Z"
              transform="translate(690 1908.164)"
              fill="#fff"
            />
            <path
              d="M1894.143,866.587H1894V341.622h0v0c-1.012-.815-10.356-8.3-26.372-19.9-20.7-14.989-42.942-29.949-66.111-44.463-32.032-20.066-64.83-38.617-97.483-55.137-19.3-9.766-38.781-18.928-57.892-27.232-20.98-9.115-42.042-17.423-62.6-24.693a1152.81,1152.81,0,0,1,125.485,20.067c33.317,7.22,66.345,15.9,98.167,25.812,28.31,8.814,50.405,16.984,63.956,22.286,14.618,5.72,22.772,9.453,22.85,9.489v93.772l.143.115ZM289.73,457.679c-24.335,0-48.614-.827-72.162-2.461-21.41-1.486-42.7-3.671-63.27-6.494a806.873,806.873,0,0,1-98.965-19.709c-12.184-3.269-24.042-6.811-35.245-10.527-8.961-2.972-17.525-6.062-25.454-9.184-13.5-5.315-20.563-8.924-20.633-8.96V244.7c.13.069,14.871,7.912,40.6,19.3,15.186,6.723,31.232,13.38,47.694,19.786,20.571,8.005,41.847,15.636,63.238,22.682a1276.742,1276.742,0,0,0,164.952,42.468c32.66,6.084,65.51,10.793,97.637,14,17.265,1.721,34.665,3.04,51.717,3.921,17.822.921,35.757,1.387,53.309,1.387,15.758,0,31.608-.376,47.111-1.117,16.042-.767,32.17-1.947,47.934-3.507,16.284-1.611,32.637-3.674,48.605-6.131,16.469-2.533,33-5.558,49.122-8.989,72.406-15.406,136.118-31.24,194.775-48.408-30.428,16.013-55.9,28.855-80.172,40.414-30.025,14.3-58.153,26.606-85.992,37.616-66.168,26.17-131.008,45.023-198.225,57.638-20.655,3.876-41.47,7.286-61.869,10.134-19.525,2.726-39.185,5.01-58.433,6.788C360.135,456,324.379,457.678,289.73,457.679ZM880.7,300.091v0c18.3-9.63,36.465-19.391,54.034-28.831l.029-.016c30.648-16.466,59.6-32.02,89.272-47,15.943-8.046,30.563-15.149,44.7-21.715,15.814-7.346,30.644-13.849,45.337-19.88a787.883,787.883,0,0,1,94.432-32.333c16.621-4.488,33.448-8.355,50.01-11.493,17.328-3.283,34.986-5.886,52.484-7.737a484.592,484.592,0,0,1,50.771-2.63,548.36,548.36,0,0,1,57.1,3.064c18.372,1.932,37.333,4.82,56.358,8.585,18,3.562,36.532,8,55.07,13.195,17.458,4.89,35.371,10.574,53.241,16.894-17.8-1.834-35.78-3.245-53.453-4.193-18.709-1-37.559-1.511-56.026-1.511-20.428,0-40.96.622-61.028,1.848-21.129,1.291-42.327,3.288-63.005,5.935-72.168,9.238-131.057,20.257-185.326,34.677-22.4,5.952-44.245,12.513-68.75,20.648-21.817,7.243-42.944,14.8-65.31,22.808l-.027.01-.018.006c-21.408,7.661-43.544,15.583-68.066,23.862C934.726,283.672,907.96,292.113,880.7,300.091Z"
              transform="translate(690 1908.164)"
              fill="#ff824e"
              opacity="0.2"
            />
          </g>
        </svg>
      </BackgroundInner>
    </BackgroundWrapper>
  )
}

export default Background
